import React from 'react'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled
} from '@mui/material'
import { IconButton, Typography, Button } from '@evocolabs/orkaui'
import Close24 from '@evocolabs/icons/lib/Close24'

const Wrapper = styled(Dialog)`
  & .MuiDialog-paper {
    width: 600px;
    padding: 40px 56px 32px;
    border-radius: 12px;
    ${(props) => props.theme.breakpoints.down('md')} {
      padding: 32px 0;
      margin: 32px 0;
    }
  }
  & .MuiDialog-paperScrollBody {
    max-width: calc(100% - 32px);
  }
`
const Title = styled(DialogTitle)`
  padding: 0 24px;
`
const Content = styled(DialogContent)`
  padding: 0 24px 32px;
  margin-top: 24px;
`
const Actions = styled(DialogActions)`
  padding: 0 24px;
  justify-content: center;
`
const IconWrapper = styled(Box)`
  position: absolute;
  top: 8px;
  right: 8px;
`

const AlertDialog = ({ open, setOpen }) => {
  return (
    <Wrapper open={open}>
      <IconWrapper>
        <IconButton onClick={() => setOpen(false)}>
          <Close24 />
        </IconButton>
      </IconWrapper>
      <Title>
        <Typography variant="h4">Date/Time unselected.</Typography>
      </Title>
      <Content>
        <Typography variant="body1">
          Please check if you have selected both date and time.
        </Typography>
      </Content>
      <Actions>
        <Button
          size="large"
          style={{ width: '116px' }}
          handleClick={() => setOpen(false)}
        >
          OK
        </Button>
      </Actions>
    </Wrapper>
  )
}

const ErrorDialog = ({ open, setOpen }) => {
  return (
    <Wrapper open={open}>
      <IconWrapper>
        <IconButton onClick={() => setOpen(false)}>
          <Close24 />
        </IconButton>
      </IconWrapper>
      <Title>
        <Typography variant="h4">Uh Oh, Something Went Wrong</Typography>
      </Title>
      <Content>
        <Typography variant="body1">
          Oops! There seems to be something wrong with the network. Please try
          again, or contact us at support@hiorka.com.
        </Typography>
      </Content>
      <Actions>
        <Button
          size="large"
          style={{ width: '116px' }}
          handleClick={() => setOpen(false)}
        >
          OK
        </Button>
      </Actions>
    </Wrapper>
  )
}

export default AlertDialog
export { ErrorDialog }
